var path = 'directives/saveButton.html';
var html = "<button data-ng-class=\"{'btn-saveButton--success': state.success || state.init, 'btn-saveButton--operation': state.pending, 'btn-saveButton--failure': state.failed}\" class=\"btn btn--saveButton\"> <i data-ng-if=\"state.success && successIcon\" class=\"fa fa-fw {{successIcon}}\"></i> <i data-ng-if=\"state.init && initIcon\" class=\"fa fa-fw {{initIcon}}\"></i> <i data-ng-if=\"state.failed && failureIcon\" class=\"fa fa-fw {{failureIcon}}\"></i> <i data-ng-if=state.pending class=\"saveButton-spinner fa fa-fw fa-spinner fa-spin\"></i> <span ng-transclude></span> </button> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./views/directives/saveButton.html
// module id = cA1Q
// module chunks = 1 2 3 4 5